"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioDeclarableAttribute = void 0;
// Not sure what will be the declarable attribute of choice for the audio creatives, for those "test" ones
// on IPONWEB it was the "InstreamVastVideoType: Non Skippable Instream Video"
const audioDeclarableAttribute = {
    id: 2,
    name: 'InstreamVastVideoType: Non Skippable Instream Video',
};
exports.audioDeclarableAttribute = audioDeclarableAttribute;
//# sourceMappingURL=AudioDeclarableAttributes.js.map